import ITCAvantGardeGothicPro from '../images/style-pack-fonts/itc-avant-garde-gothic-pro.svg';
import LoraFoundersGrotesk from '../images/style-pack-fonts/lora-founders-grotesk.svg';
import NaicheExtraBold from '../images/style-pack-fonts/naiche-extra-bold.svg';
import PoppinsMedium from '../images/style-pack-fonts/poppins-medium.svg';
import BeniBlack from '../images/style-pack-fonts/beni-black.svg';

interface Template {
	type: string,
	url: string,
	thumbnail: string,
	default: Record<string, string | object>;
}

export const STATIC_ASSET_URL = process.env.REACT_APP_ASSET_URL
	? process.env.REACT_APP_ASSET_URL
	: 'https://greenroom-static-assets.greenroom-dev.brandlive.cloud';

export const nonEditTypes = [
	'brandlive-back-to-school-countdown',
];

export const genericOverlayTemplate: Template = {
	type: 'generic',
	url: '',
	thumbnail: '',
	default: {
		userName: 'Isabella Cooper',
		userSubhead: 'VP of Marketing',
		shape: 'Rounded',
		color1: '#FFFFFF',
		color2: '#040303',
		color3: '#F79BC4',
		color4: '#FBE045',
	},
};

export const contentTemplateStyles: Template[] = [
	{
		type: 'brandlive-back-to-school',
		url: `${STATIC_ASSET_URL}/title_templates/1.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/1.png`,
		default: {
			userName: 'Isabella Cooper',
			userSubhead: 'VP of Marketing',
			shape: 'Pointed',
			color1: '#FCE33D',
			color2: '#F9A4CB',
			color3: '#FA5200',
			color4: '#FFFFFF',
			color5: '#040303',
		},
	},
	{
		type: 'brandlive-back-to-school',
		url: `${STATIC_ASSET_URL}/title_templates/back-to-school/back-to-school-lower2.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/back-to-school/thumbs/back-to-school-lower2.png`,
		default: {
			userName: 'Isabella Cooper',
			userSubhead: 'VP of Marketing',
			shape: 'Rounded',
			color1: '#FCE33D',
			color2: '#F9A4CB',
			color3: '#FA5200',
			color4: '#FFFFFF',
			color5: '#040303',
		},
	},
	{
		type: 'brandlive-lifelabs',
		url: `${STATIC_ASSET_URL}/title_templates/2.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/2.png`,
		default: {
			userName: 'Lucas Parker',
			userPronouns: 'he/him',
			userSubhead: 'Breze',
			color1: '#312F3D',
			color2: '#D4DFE3',
			color3: '#FE6363',
		},
	},
	{
		type: 'brandlive-selfridges',
		url: `${STATIC_ASSET_URL}/title_templates/3.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/3.png`,
		default: {
			userText1: 'Keep It Simple',
			userText2: 'Brandlive Studios',
			userText3: '',
			color1: '#BF402F',
			color2: '#FCFCDC',
		},
	},
	{
		type: 'brandlive-style-pack-20',
		url: `${STATIC_ASSET_URL}/title_templates/misc/misc-lower.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-lower.png`,
		default: {
			userName: 'Daniel',
			userSurname: 'Murphy',
			userSubhead: 'Brandlive Studios',
			color2: '#000000',
			color1: '#FFFFFF',
			color3: '#BAF3FD',
			color4: '#FFFFFF',
			color5: '#FBF5A8',
			color6: '#ED73E0',
		},
	},
	{
		type: 'brandlive-back-to-school',
		url: `${STATIC_ASSET_URL}/title_templates/5.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/5.png`,
		default: {
			userName: 'Back to School',
			userSubhead: '',
			shape: 'Rounded',
			color1: '#FE42E9',
			color2: '#50851D',
			color3: '#D39309',
			color4: '#FFFFFF',
			color5: '#040303',
		},
	},
	{
		type: 'brandlive-lifelabs',
		url: `${STATIC_ASSET_URL}/title_templates/6.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/6.png`,
		default: {
			userName: 'Business Casual',
			userPronouns: ' ',
			userSubhead: 'Brandlive Studios',
			color1: '#17284F',
			color2: '#F89C3E',
			color3: '#0885A6',
		},
	},
	{
		type: 'brandlive-selfridges',
		url: `${STATIC_ASSET_URL}/title_templates/7.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/7.png`,
		default: {
			userText1: 'Keep It Simple',
			userText2: '',
			userText3: '',
			color1: '#9BC1BB',
			color2: '#1F2933',
		},
	},
	{
		type: 'brandlive-style-pack-20',
		url: `${STATIC_ASSET_URL}/title_templates/8.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/8.png`,
		default: {
			userName: 'Make a',
			userSurname: 'Splash',
			userSubhead: 'Brandlive Studios',
			color2: '#040303',
			color1: '#FFFFFF',
			color3: '#52A230',
			color4: '#FFFFFF',
			color5: '#FBF5A8',
			color6: '#2B5514',
		},
	},
	{
		type: 'brandlive-back-to-school',
		url: `${STATIC_ASSET_URL}/title_templates/9.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/9.png`,
		default: {
			userName: 'Back to School',
			userSubhead: '',
			shape: 'Pointed',
			color1: '#F93D41',
			color3: '#000000',
			color2: '#FED522',
			color4: '#FFFFFF',
			color5: '#040303',
		},
	},
	{
		type: 'brandlive-lifelabs',
		url: `${STATIC_ASSET_URL}/title_templates/10.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/10.png`,
		default: {
			userName: 'Business Casual',
			userPronouns: 'he/him',
			userSubhead: 'Brandlive Studios',
			color1: '#E18B7B',
			color2: '#384FF3',
			color3: '#141742',
		},
	},
	{
		type: 'brandlive-selfridges',
		url: `${STATIC_ASSET_URL}/title_templates/11.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/11.png`,
		default: {
			userText1: 'Keep It Simple',
			userText2: 'Brandlive Studios',
			userText3: '',
			color1: '#4CB05D',
			color2: '#000000',
		},
	},
	{
		type: 'brandlive-selfridges',
		url: `${STATIC_ASSET_URL}/title_templates/rothko/rothko-lower.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/rothko/thumbs/rothko-lower.png`,
		default: {
			userText1: 'Chloe Bennett',
			userText2: 'Chief Innovation Officer',
			userText3: '',
			color1: '#4CB05D',
			color2: '#000000',
		},
	},
	{
		type: 'brandlive-style-pack-20',
		url: `${STATIC_ASSET_URL}/title_templates/12.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/thumbs/12.png`,
		default: {
			userName: 'Make a',
			userSurname: 'Splash',
			userSubhead: 'Brandlive Studios',
			color2: '#000000',
			color1: '#F88D00',
			color3: '#DA652F',
			color4: '#FBFAEE',
			color5: '#F4C9A3',
			color6: '#94FCF8',
		},
	},
	{
		type: 'brandlive-academy',
		url: `${STATIC_ASSET_URL}/title_templates/academy/academy-lower.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/academy/thumbs/academy-lower.png`,
		default: {
			userName: 'Olivia Walker',
			userSurname: 'Chief Brand Officer',
		},
	},
	{
		type: 'brandlive-mondrian',
		url: `${STATIC_ASSET_URL}/title_templates/mondrian/mondrian-lower.webm`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/mondrian/thumbs/mondrian-lower.png`,
		default: {
			userName: 'Jessica Jones',
			userSurname: 'Creative Operations',
		},
	},
	{
		type: 'brandlive-walkups',
		url: `${STATIC_ASSET_URL}/title_templates/misc/misc-walkup.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture.png`,
		default: {
			eventName: 'Brandlive Studios',
			'speaker1-headshot': `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture.png`,
			'speaker1-name': 'Daniel Murphy',
			'speaker1-position': 'Future Horizons',
			'speaker1-company': '',
			'speaker2-headshot': `${STATIC_ASSET_URL}/title_templates/misc/thumbs/misc-walkup-picture-2.png`,
			'speaker2-name': 'Nell Lynch',
			'speaker2-position': 'Future Horizons',
			'speaker2-company': '',
			'oneToManyField': 'speaker${i}-headshot',
			'oneToManyLabel': 'Presenter',
			'button-text': 'Add presenter',
			'button-icon': 'SHARE',
			bgColor: '#67878F',
			accentColor: '#9CC0BA',
			textColor: '#E6E1D5',
		},
	},
	{
		type: 'api-brandlive-4',
		url: `${STATIC_ASSET_URL}/title_templates/rothko/rothko-countdown.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/rothko/thumbs/rothko-countdown.png`,
		default: {
			'seconds': `${5*60}`,
			'color-background': '#4CB05E',
			'color-foreground': '#000000',
			'color-accent': '#15B7FD',
		},
	},
	{
		type: 'api-brandlive-5',
		url: `${STATIC_ASSET_URL}/title_templates/topo/topo-walkup.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/topo/thumbs/topo-walkup.png`,
		default: {
			'logo': `${STATIC_ASSET_URL}/title_templates/topo/thumbs/logo.png`,
			'image': `${STATIC_ASSET_URL}/title_templates/topo/thumbs/image.jpg`,
			'text-1': 'Introducing',
			'text-2': 'Lucas Parker',
			'text-3': `From`,
			'color-background': '#312F3D',
			'color-foreground': '#D4DFE3',
			'color-accent': '#FE6363',
		},
	},
	{
		type: 'api-brandlive-6',
		url: `${STATIC_ASSET_URL}/title_templates/topo/topo-countdown.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/topo/thumbs/topo-countdown.png`,
		default: {
			'logo': `${STATIC_ASSET_URL}/title_templates/topo/thumbs/logo.png`,
			'image': `${STATIC_ASSET_URL}/title_templates/topo/thumbs/image.jpg`,
			'text-line-1': 'Allhands',
			'text-line-2': 'The show begins in',
			'seconds': '300',
			'color-background': '#312F3D',
			'color-accent': '#D77F72',
			'color-foreground': '#FFFFFF',
			'color-trim': '#FFFFFF',
		},
	},
	{
		type: 'api-brandlive-3',
		url: `${STATIC_ASSET_URL}/title_templates/rothko/rothko-walkup.mp4`,
		thumbnail: `${STATIC_ASSET_URL}/title_templates/rothko/thumbs/rothko-walkup.png`,
		default: {
			'text-1': 'Introducing',
			'text-2': 'Chloe Bennett',
			'text-3': 'Chief Innovation Officer',
			'color-background-1': '#000000',
			'color-background-2': '#56B969',
			'color-text': '#000000',
			'color-underline': '#158FFD',
			'color-box': '#D6E0E2',
		},
	},
];

export interface StylePackOption {
	name: string, // name of the option
	type: string, // colorway or font
	style_pack_types: string[], // style packs that this option is available for
	data: {
		colors?: string[], // array of hex colors for colorway
		preview?: string, // svg preview for font
	},
}

export const stylePackOptions: StylePackOption[] = [
	{
		name: 'Candy Playground',
		type: 'colorway',
		style_pack_types: [
			'brandlive-back-to-school',
		],
		data: {
			colors: [
				'#FA5200',
				'#FCE33D',
				'#FFFFFF',
				'#FFD1D0',
				'#F9A4CB',
				'#040303',
			],
		},
	},
	{
		name: 'Azure Harmony',
		type: 'colorway',
		style_pack_types: [
			'brandlive-selfridges',
		],
		data: {
			colors: [
				'#4CB05D',
				'#D1DCDF',
				'#14B7FD',
				'#000000',
			],
		},
	},
	{
		name: 'Deep Lavender Lake',
		type: 'colorway',
		style_pack_types: [
			'brandlive-lifelabs',
		],
		data: {
			colors: [
				'#413786',
				'#322F3D',
				'#1C3C3A',
			],
		},
	},
	{
		name: 'Oceanic Ember',
		type: 'colorway',
		style_pack_types: [
			'brandlive-mondrian',
		],
		data: {
			colors: [
				'#0AC28B',
				'#D5614A',
				'#2EBBD5',
				'#239CD4',
				'#0C2E32',
				'#040303',
			],
		},
	},
	{
		name: 'Galactic Yearbook',
		type: 'colorway',
		style_pack_types: [
			'brandlive-academy',
		],
		data: {
			colors: [
				'#ED0201',
				'#FFBC1E',
				'#FFF85C',
				'#FF6AE6',
				'#5AE3FF',
				'#09083F',
				'#09083F',
			],
		},
	},
	{
		name: 'Misty Horizon',
		type: 'colorway',
		style_pack_types: [
			'brandlive-walkups',
		],
		data: {
			colors: [
				'#67878F',
				'#E4E1D5',
				'#9CC0BA',
				'#67878F',
			],
		},
	},
	{
		name: 'Ethereal Elegance',
		type: 'colorway',
		style_pack_types: [
			'brandlive-style-pack-20',
		],
		data: {
			colors: [
				'#B9F6FB',
				'#F9FBB4',
				'#FFFFFF',
				'#DE5AD1',
				'#000000',
			],
		},
	},
	{
		name: 'Naiche Extra Bold',
		type: 'font',
		style_pack_types: [
			'brandlive-back-to-school',
		],
		data: {
			preview: NaicheExtraBold,
		},
	},
	{
		name: 'ITC Avant Garde Gothic Pro',
		type: 'font',
		style_pack_types: [
			'brandlive-selfridges',
		],
		data: {
			preview: ITCAvantGardeGothicPro,
		},
	},
	{
		name: 'Lora Founders Grotesk',
		type: 'font',
		style_pack_types: [
			'brandlive-lifelabs',
		],
		data: {
			preview: LoraFoundersGrotesk,
		},
	},
	{
		name: 'Tusker Grotesk',
		type: 'font',
		style_pack_types: [
			'brandlive-mondrian',
		],
		data: {
			preview: BeniBlack,
		},
	},
	{
		name: 'Poppins Medium',
		type: 'font',
		style_pack_types: [
			'brandlive-academy',
			'brandlive-walkups',
			'brandlive-style-pack-20',
		],
		data: {
			preview: PoppinsMedium,
		},
	},
];
